module.exports = __webpack_public_path__ + "static/media/TipsBCard.dac5c012.png";